/** Standardized dropdown values for line pipe (UI); stored as strings on the line. */
export const LINE_PIPE_WALL_THICKNESS_OPTIONS = [
  'SCH 40',
  'SCH 80',
  'SCH 160',
  'XS (Extra Strong)',
  'XXS (Double extra strong)'
] as const;

export const LINE_PIPE_END_FINISH_OPTIONS = ['Beveled', 'Plain', 'Threaded'] as const;

export const LINE_PIPE_MFG_OPTIONS = ['SMLS', 'ERW', 'LSAW/SSAW'] as const;
